// import AuthLayout from "../../components/";
import {
    Button,
    Col,
    Image,
    Layout,
    List,
    Row
} from "antd";
import {
    FaCheckCircle
} from "react-icons/fa";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Function";
import { useEffect } from "react";
// import router from "next/router";

function OutSourcing() {
    const navigate = useNavigate();

    const data1 = [
        {
            title: "Attach a logo to the portal.",
        },
        {
            title: "Create a referral code for users to self-enroll into a portal.",
        },
    ];

     useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <>
            
            <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c34.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Navigating Successful Custodial Service Outsourcing: A 3-Step Approach</h4>
                                        <p className="text-p-16">
                                        Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                        Administrators, Custodial Supervisor
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                        Embarking on the journey of outsourcing custodial facility services? Look no further than the “Navigating Successful Custodial Service Outsourcing: A 3-Step Approach” training. This training session is a must-attend for those contemplating the outsourcing route, as it promises to streamline your decision-making process, enhance operational efficiency, and pave the way for a prosperous outcome. Delve into the intricacies of a comprehensive self-assessment process, explore the essential components of crafting a Request for Proposal (RFP), and gain insights into the 8Cs framework—a valuable tool for evaluating potential contract cleaning services. By attending, you equip yourself with the knowledge and tools necessary to make informed decisions and ensure the success of your outsourcing venture.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>


             
               


            </Layout>
        </>
    );
}

export default OutSourcing;
